import * as AnalyticsBrowser from "@amplitude/marketing-analytics-browser";
import { Options } from "@amplitude/marketing-analytics-browser/lib/esm/typings/browser-client";
import config from "config";

export function init(userId?: string, options?: Options): void {
  AnalyticsBrowser.init(config.AMPLITUDE_API_KEY as string, userId, options);
}

export function track(
  eventInput: string | AnalyticsBrowser.Types.BaseEvent,
  eventProperties?: Record<string, any> | undefined,
  eventOptions?: AnalyticsBrowser.Types.EventOptions | undefined
): void {
  AnalyticsBrowser.track(eventInput, eventProperties, eventOptions);
}
